import axios from "axios";
import auth from "@/services/auth.svc";

const SEARCH_API = process.env.VUE_APP_SEARCH_API_BASE;

var http = axios.create({
  baseURL: SEARCH_API
});
http.interceptors.request.use(function(config) {
  return auth
    .getSearchToken()
    .then(token => {
      let headers = config.headers;
      let authHeader = buildAuthHeader(token);
      headers = Object.assign(headers, authHeader);
      config = Object.assign(config, { headers });
      return config;
    })
    .catch(err => {
      console.error(err);
    });
});
function buildAuthHeader(token) {
  if (token) {
    return {
      Authorization: `Bearer ${token}`
    };
  }
}

function get(url) {
  return http
    .get(url)
    .then(res => {
      return res;
    })
    .catch(err => {
      throw err;
    });
}
function post(url, payload) {
  return http
    .post(url, payload)
    .then(res => {
      return res;
    })
    .catch(err => {
      console.error(err);
      throw err;
    });
}

function getIndices() {
  return get("/manage/GetIndices")
    .then(res => {
      return res.data;
    })
    .catch(err => console.dir(err));
}
function saveIndexDetails(index) {
  return post("/manage/SaveIndexDetails", index)
    .then(res => {
      return res.data;
    })
    .catch(err => console.error(err));
}
function testSearch(query, type) {
  return get(`/search/search?query=${query || ""}&type=${type || ""}`)
    .then(res => {
      return res.data;
    })
    .catch(err => console.error(err));
}
function completionSuggest(query, type) {
  return get(
    `/search/completionSuggest?query=${query || ""}&type=${type || ""}`
  ).then(res => {
    return res.data;
  });
}
function getComparators() {
  return get("/manage/GetAllComparators")
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.error(err);
    });
}
function getDataTypes() {
  return get("/search/getAvailableDataTypes")
    .then(res => {
      return res.data;
    })
    .catch(err => {
      console.error(err);
    });
}

export default {
  getComparators,
  getDataTypes,
  getIndices,
  saveIndexDetails,
  testSearch,
  completionSuggest
};
